import styled from "styled-components";

import { ReactComponent as ArrowRight } from "../../../../assets/arrowRight.svg";

export const Container = styled.div`
  grid-area: orders;
  border-radius: 8px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 24px 32px;
  border-bottom: 1px solid var(--gray-light-line);

  > span {
    color: var(--gray);
    font-family: var(--semiBold);
  }

  > a > p {
    color: var(--gray);
    font-family: var(--regular);
  }
`;

export const OrdersWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
`;

export const Order = styled.div`
  align-items: center;
  justify-content: space-between;
  position: relative;

  & + div {
    margin-top: 16px;

    &::before {
      content: "";
      background: var(--gray-light-line);
      height: 18px;
      width: 1px;
      position: absolute;
      left: 20px;
      top: -16px;
    }
  }
`;

export const IconWrapper = styled.div`
  border-radius: 50%;
  border: 1px solid #718ebf;
`;

export const OrderDetails = styled.div`
  display: flex;
  align-items: center;
`;

export const BalanceDetails = styled.div`
  display: flex;
  align-items: center;
`;

export const Type = styled.span`
  color: var(--gray-light-order);
  font-family: var(--regular);
`;

export const DateUltimosLancamentos = styled.span`
  color: #718ebf;
  font-family: var(--regular);
`;

export const Name = styled.p`
  color: var(--gray);
  font-family: var(--regular);
`;

export const Icon = styled.img``;

export const InfoOrder = styled.div``;

interface BalanceProps {
  credit: boolean | string;
}

export const Balance = styled.p<BalanceProps>`
  color: ${({ credit }) => (credit ? "var(--green)" : "var(--red)")};

  font-family: var(--regular);
`;

export const ArrowIcon = styled(ArrowRight)<BalanceProps>`
  fill: ${({ credit }) => (credit && credit !== "false" ? "var(--green)" : "var(--boxText)")};
  color: ${({ credit }) => (credit && credit !== "false" ? "var(--green)" : "var(--boxText)")};
  margin-left: 12px;

  path {
    color: ${({ credit }) => (credit && credit !== "false" ? "var(--green)" : "var(--boxText)")};
    fill: currentcolor;
  }
`;
export const WrapperMobile = styled.div`
  width: 30px;
  position: fixed;
  bottom: 20px;
  right: 50px;
  transition: width 0.3s ease-in-out;
  z-index: 1000;

  &:hover {
    width: 40px;
  }
`;

export const DivMobile = styled.div`
  position: relative;
`;

export const Tooltip = styled.div<{ show: boolean }>`
  display: ${(props) => (props.show ? "block" : "none")};
  position: absolute;
  top: 0px;
  left: -80px;
  width: 150px;
  transform: translateX(-50%);
  background-color: #f5f5f5;
  padding: 8px;
  border-radius: 4px;
  animation: fade-in 0.3s ease-in-out;
  z-index: 100000;
  border: 2px solid var(--gray);
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
